






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'
import {InputEsconderMotoristaSchema} from '@/schema/resource/EsconderMotorista/InputEsconderMotoristaSchema'

@Component
export default class PersistEsconderMotoristaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputEsconderMotoristaSchema()
  esconderMotorista = new EsconderMotorista()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.esconderMotorista.getEsconderMotorista(id)
    }

    $.await.done('getEsconderMotorista')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.esconderMotorista.persistEsconderMotorista()
    await Helper.successAndPush(
      'system.success.persist',
      '/esconder-motorista/list'
    )
  }
}
